import {
    totalCountTooltipLabel,
    totalCountUnreadCountTooltipLabel,
    totalCountsUnreadCountTooltipLabel,
    totalCountContextMenuLabel,
    totalCountUnreadCountContextMenuLabel,
    totalCountsUnreadCountContextMenuLabel,
} from './folderCountUtility.locstring.json';
import loc from 'owa-localize';
import type DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';

const FOLDERS_DEFAULTING_TO_TOTAL_COUNT: DistinguishedFolderIdName[] = [
    'drafts',
    'junkemail',
    'outbox',
    'notes',
    'scheduled',
];

/**
 * Returns the default folder-count display mode for a folder when the user
 * has not explicitly chosen one via the context menu.
 */
export function getDefaultFolderCountDisplayMode(
    distinguishedFolderId: string | undefined
): 'unread' | 'total' {
    return distinguishedFolderId &&
        FOLDERS_DEFAULTING_TO_TOTAL_COUNT.indexOf(
            distinguishedFolderId as DistinguishedFolderIdName
        ) >= 0
        ? 'total'
        : 'unread';
}

/**
 * Function returns localized tooltip label for a folder given its display name and counts of total items and unread items
 * @param displayName - the display name for the folder
 * @param totalCount - count of items in the folder
 * @param unreadCount - count of unread items in the folder
 * */
export function buildUnreadTotalCountTooltip(
    displayName: string,
    totalCount: number,
    unreadCount: number
): string {
    if (totalCount > 0) {
        if (totalCount === 1) {
            return loc(totalCountUnreadCountTooltipLabel, displayName, totalCount, unreadCount);
        } else {
            return loc(totalCountsUnreadCountTooltipLabel, displayName, totalCount, unreadCount);
        }
    }
    return loc(totalCountTooltipLabel, displayName, totalCount);
}

/**
 * Function returns localized context menu label for a folder given the counts of its total items and unread items
 * @param totalCount - count of items in the folder
 * @param unreadCount - count of unread items in the folder
 */
export function buildUnreadTotalCountContextMenuLabel(
    totalCount: number,
    unreadCount: number
): string {
    if (totalCount > 0) {
        if (totalCount === 1) {
            return loc(totalCountUnreadCountContextMenuLabel, totalCount, unreadCount);
        } else {
            return loc(totalCountsUnreadCountContextMenuLabel, totalCount, unreadCount);
        }
    }
    return loc(totalCountContextMenuLabel, totalCount);
}
